(function () {
    "use strict";

    angular
        .module("app.productDetail")
        .factory("ProductDetailService", ProductDetailService);

    ProductDetailService.$inject = ["$http", "$q"];

    function ProductDetailService($http, $q) {
        var service = {
            getProduct: getProduct,
            getMainProduct: getMainProduct,
            getProductMediaList: getProductMediaList,
            getGroupProductList: getGroupProductList,
            getVariantProduct: getVariantProduct,
            getVariantProductList: getVariantProductList,
            getLastViewedProductList: getLastViewedProductList,
            getRelatedProducts: getRelatedProducts,
            getRelatedProductList: getRelatedProductList,
            getProductReviewList: getProductReviewList,
            getProductWithCode: getProductWithCode,
        };

        return service;

        function getProduct(productId) {
            var deferred = $q.defer();
            var url = "/api/Product/";
            $http
                .get(url + productId)
                .then(getProductComplete)
                .catch(getProductFailed);

            function getProductComplete(response) {
                deferred.resolve(response);
            }

            function getProductFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getProductWithCode(filterParams) {
            var deferred = $q.defer();
            var url = "/api/Product/GetProductWithCode/";
            $http
                .get(url, {
                    params: filterParams,
                })
                .then(getProductWithCodeComplete)
                .catch(getProductWithCodeFailed);

            function getProductWithCodeComplete(response) {
                deferred.resolve(response);
            }

            function getProductWithCodeFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getProductMediaList(productId) {
            var deferred = $q.defer();
            var url = "/api/Product/GetProductMediaList/";
            $http
                .get(url + productId)
                .then(getProductMediaListComplete)
                .catch(getProductMediaListFailed);

            function getProductMediaListComplete(response) {
                deferred.resolve(response);
            }

            function getProductMediaListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getMainProduct(filterParams) {
            var deferred = $q.defer();
            var url = "/api/Product/GetMainProduct/";
            $http
                .get(url, {
                    params: filterParams,
                })
                .then(getMainProductComplete)
                .catch(getMainProductFailed);

            function getMainProductComplete(response) {
                deferred.resolve(response);
            }

            function getMainProductFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getGroupProductList(productId) {
            var deferred = $q.defer();
            var url = "/api/Product/GetGroupProductList/";
            $http
                .get(url + productId)
                .then(getGroupProductListComplete)
                .catch(getGroupProductListFailed);

            function getGroupProductListComplete(response) {
                deferred.resolve(response);
            }

            function getGroupProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getVariantProduct(filterParams) {
            var deferred = $q.defer();
            var url = "/api/Product/GetVariantProduct/";
            $http
                .get(url, {
                    params: filterParams,
                })
                .then(getVariantProductComplete)
                .catch(getVariantProductFailed);

            function getVariantProductComplete(response) {
                deferred.resolve(response);
            }

            function getVariantProductFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getVariantProductList(productId) {
            var deferred = $q.defer();
            var url = "/api/Product/GetVariantProductList/";
            $http
                .get(url + productId)
                .then(getVariantProductListComplete)
                .catch(getVariantProductListFailed);

            function getVariantProductListComplete(response) {
                deferred.resolve(response);
            }

            function getVariantProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getLastViewedProductList() {
            var deferred = $q.defer();
            var url = "/api/Product/GetLastViewedProductList";
            $http
                .get(url)
                .then(getLastViewedProductListComplete)
                .catch(getLastViewedProductListFailed);

            function getLastViewedProductListComplete(response) {
                deferred.resolve(response);
            }

            function getLastViewedProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getRelatedProducts(filterParams) {
            var deferred = $q.defer();
            var url = "/api/Product/GetRelatedProducts";
            $http
                .get(url, {
                    params: filterParams,
                })
                .then(getRelatedProductsComplete)
                .catch(getRelatedProductsFailed);

            function getRelatedProductsComplete(response) {
                deferred.resolve(response);
            }

            function getRelatedProductsFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getRelatedProductList(filterParams) {
            var deferred = $q.defer();
            var url = "/api/Product/GetRelatedProductList";
            $http
                .get(url, {
                    params: filterParams,
                })
                .then(getRelatedProductListComplete)
                .catch(getRelatedProductListFailed);

            function getRelatedProductListComplete(response) {
                deferred.resolve(response);
            }

            function getRelatedProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getProductReviewList(productId) {
            var deferred = $q.defer();
            var url = "/api/Product/GetProductReviewList/";
            $http
                .get(url + productId)
                .then(getProductReviewListComplete)
                .catch(getProductReviewListFailed);

            function getProductReviewListComplete(response) {
                deferred.resolve(response);
            }

            function getProductReviewListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();
